/* eslint-disable max-len */
import React, { FC } from 'react'
import { themeObject } from 'Pages/landings/newLandings/common/style'
import styled from 'styled-components'

const StyledIcon = styled.svg`
	cursor: pointer;
	width: 24px;
	height: 24px;
	min-height: 24px;
	min-width: 24px;
	z-index: 1000;
`

export const CloseIcon: FC<React.HTMLAttributes<unknown>> = () => (
	<StyledIcon viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16.8486 17.8025C17.112 18.0658 17.5391 18.0658 17.8025 17.8025C18.0658 17.5391 18.0658 17.112 17.8025 16.8486L12.8743 11.9205L17.6435 7.15137C17.9069 6.88798 17.9069 6.46094 17.6435 6.19754C17.3801 5.93415 16.953 5.93415 16.6897 6.19754L11.9205 10.9667L7.31034 6.35652C7.04695 6.09312 6.61991 6.09312 6.35652 6.35652C6.09312 6.61991 6.09312 7.04695 6.35652 7.31034L10.9667 11.9205L6.19754 16.6897C5.93415 16.953 5.93415 17.3801 6.19754 17.6435C6.46094 17.9069 6.88798 17.9069 7.15137 17.6435L11.9205 12.8743L16.8486 17.8025Z"
			fill={themeObject.colors.grey[600]}
		/>
	</StyledIcon>
)
